<div class="flex flex-row w-screen h-screen">
  <div class="w-full md:w-1/2">
    <div
      class="sticky flex flex-row gap-1 items-center justify-between p-4 border border-light-120 backdrop-blur-md"
    >
      <p class="font-bold text-2xl text-light-300">Seedio</p>
    </div>

    <div class="flex flex-col items-center justify-center gap-5 pt-8">
      <div class="flex flex-col gap-8 w-3/4 md:w-1/2 my-10">
        <h2 class="font-bold text-lg text-light-300">Login</h2>

        <form [formGroup]="form" class="flex flex-col" (ngSubmit)="onSubmit()">
          <div class="flex flex-col items-start gap-8">
            <div class="flex flex-col gap-1 w-full">
              <label class="font-medium text-base text-light-200" for="email"
                >Email</label
              >

              <input
                id="email"
                pInputText
                formControlName="email"
                type="text"
                pSize="large"
                placeholder="mail@mail.com"
                class="w-full p-inputtext"
                name="email"
                [style]="{
                  'ng-invalid ng-dirty':
                    f['email'].invalid && f['email'].touched
                }"
              />
            </div>

            <div class="flex flex-col gap-1 w-full">
              <label
                class="font-medium text-base text-light-200"
                for="password"
              >
                Password
              </label>

              <p-password
                id="password"
                formControlName="password"
                type="password"
                pSize="large"
                placeholder="**********"
                [toggleMask]="true"
                name="password"
                [feedback]="false"
                styleClass="w-full"
                inputStyleClass="w-full !py-2.5 !pl-3.5"
              />

              <!-- [todo] -->
              <!-- <a
                class="font-normal text-sm text-blue-100 hover:underline"
                href="/forgot-password"
                >Forgot password</a
              > -->
            </div>

            <div class="flex flex-col gap-2 w-full">
              <p-fluid>
                <p-button
                  type="submit"
                  label="Login"
                  size="large"
                  styleClass="w-full"
                  [disabled]="!form.valid"
                  [fluid]="true"
                />
              </p-fluid>

              <a
                class="font-normal text-sm text-blue-100 hover:underline"
                href="/home/properties"
              >
                Continue as Guest
              </a>
            </div>

            <p class="font-semibold text-base text-light-300">
              Not yet registered?
              <a
                class="font-normal text-blue-100 hover:underline"
                href="/registration"
              >
                Sign up
              </a>
            </p>
          </div>
        </form>

        <p class="text-xs text-light-170">
          By clicking Log In you agree to Seedio's
          <a
            class="font-bold underline"
            target="_blank"
            href="https://drive.google.com/file/d/1mJiu2kNuYfdkEB7xv5ZiTorlKDYDxL-i/view?usp=sharing"
            >Terms & Conditions</a
          >
          and
          <span
            class="font-bold underline cursor-pointer"
            (click)="showKeyRiskDialog = !showKeyRiskDialog"
            >Key Risks</span
          >
        </p>

        <p-dialog
          header="Key Risks – Seedio"
          [modal]="true"
          [(visible)]="showKeyRiskDialog"
          [style]="{ width: '576px' }"
        >
          <div class="flex flex-col gap-8">
            <div class="flex flex-col gap-2">
              <h2 class="font-bold text-light-300 text-xl">No Guarantee</h2>
              <p class="text-light-100 text-base">
                Investing through Seedio involves risk. Past performance does
                not guarantee future returns. Any expected or projected figures
                are purely indicative and may not reflect actual future results.
                Your capital is at risk and is not protected or guaranteed.
              </p>
            </div>

            <div class="flex flex-col gap-2">
              <h2 class="font-bold text-light-300 text-xl">
                Investment Horizon and Liquidity
              </h2>
              <p class="text-light-100 text-base">
                Investments on Seedio are intended to be held for the full
                investment period, typically 5 years, and are not publicly
                listed. Seedio may offer an Exit Window — a limited-time
                secondary transfer mechanism — during which investors may
                attempt to sell their shares to others via the platform.
                However, this window is available only at specific intervals and
                for a short duration. There is no guarantee of liquidity during
                these periods, nor assurance that you will be able to exit your
                investment early. You should invest only if you are prepared to
                hold the investment until the end of the term.
              </p>
            </div>

            <div class="flex flex-col gap-2">
              <h2 class="font-bold text-light-300 text-xl">
                Ownership Structure
              </h2>
              <p class="text-light-100 text-base">
                Investors on Seedio do not directly own real estate assets.
                Instead, investments are made through shares in Greek-based
                Special Purpose Vehicles (SPVs) that hold title to the
                properties. This structure means you will not have direct rights
                over the physical property, but rather an indirect, fractional
                economic interest.
              </p>
            </div>

            <div class="flex flex-col gap-2">
              <h2 class="font-bold text-light-300 text-xl">
                Market Risks and Uncertainty
              </h2>
              <p class="text-light-100 text-base">
                Real estate is subject to market volatility, economic
                conditions, regulatory changes, and location-specific factors.
                Property values and rental income can fluctuate, and anticipated
                returns may not materialize. There may be delays in rental
                distributions, or properties may remain vacant or be difficult
                to resell at the end of the term. Local legal and tax frameworks
                may also affect your investment outcome.
              </p>
            </div>

            <div class="flex flex-col gap-2">
              <h2 class="font-bold text-light-300 text-xl">
                Regulatory and Foreign Ownership Considerations
              </h2>
              <p class="text-light-100 text-base">
                While Greece allows foreign investment in property, certain
                restrictions or bureaucratic delays may apply depending on the
                region and investor nationality. These may impact the pool of
                future buyers and affect exit opportunities.
              </p>
            </div>

            <div class="flex flex-col gap-2">
              <h2 class="font-bold text-light-300 text-xl">
                Platform and Operational Risks
              </h2>
              <p class="text-light-100 text-base">
                Seedio facilitates investment via technology and third-party
                legal and property management providers. If Seedio were to cease
                operations, you may experience delays, additional costs, or loss
                of access to platform-based services such as document retrieval,
                reporting, or secondary transfers.
              </p>
            </div>

            <div class="flex flex-col gap-2">
              <h2 class="font-bold text-light-300 text-xl">
                Use of Borrowed Funds
              </h2>
              <p class="text-light-100 text-base">
                Investing using borrowed capital (e.g. loans, credit) increases
                risk. If your investment loses value or underperforms, you
                remain liable to repay the borrowed amount and may face
                financial hardship.
              </p>
            </div>

            <div class="flex flex-col gap-2">
              <h2 class="font-bold text-light-300 text-xl">
                No Investment Advice
              </h2>
              <p class="text-light-100 text-base">
                Seedio does not offer financial, legal, or tax advice.
                Information provided on the platform is for informational
                purposes only. All investment decisions must be based on your
                own research and, where appropriate, advice from independent
                professionals.
              </p>
            </div>

            <div class="flex flex-col gap-2">
              <h2 class="font-bold text-light-300 text-xl">Disclaimers</h2>
              <ul class="text-light-100 text-base">
                <li>
                  Investments in Greek real estate carry inherent risks. Your
                  capital is at risk and returns are not guaranteed.
                </li>
                <li>
                  Real estate values may decrease, and rental income may be
                  reduced or delayed.
                </li>
                <li>
                  Forecasts and historical performance should not be treated as
                  reliable indicators of future performance.
                </li>
                <li>
                  Market downturns, legal changes, or platform-level disruptions
                  may affect your ability to exit or achieve expected outcomes.
                </li>
              </ul>
            </div>
          </div>
          <div class="flex justify-end">
            <p-button
              label="Close"
              [link]="true"
              (onClick)="showKeyRiskDialog = false"
            />
          </div>
        </p-dialog>
      </div>
    </div>
  </div>
  <div class="flex-1 hidden md:flex w-1/2">
    <img class="w-full" src="assets/images/seedio-login.webp" />
  </div>
</div>
